<template>
  <div class="w-full text-gray-600 leading-relaxed uppercase">
    <div @click="mail()" class="text-right cursor-pointer mt-6 lg:mt-0">info at acs47 dot de</div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  // components: {
  //   HelloWorld
  // }

  methods: {
    mail() {
      window.location.href = atob('bWFpbHRvOmluZm9AYWNzNDcuZGU=');
    }
  }
}
</script>
